import React from 'react';
import {Route} from "react-router";

import config from '../../config';

import NavigationAttributes from '../NavigationAttributes';
import NavigationSummary from '../NavigationSummary';

const NavigationGeneral = (props) => (
  <React.Fragment>
    <Route
      path={`/${config.attrBase}/:attrSlug`}
      render={(routerProps) => <NavigationAttributes {...props} {...routerProps}/>}
    />
    <Route
      path={`/summary`}
      render={(routerProps) => <NavigationSummary {...props} {...routerProps}/>}
    />
  </React.Fragment>
);

export default NavigationGeneral;